export default "__VITE_ASSET__c5c774f3__"